<template>
  <section class="content_container plan_confirm">
    <div class="thank_you text-center">
      <div class="img">
        <img :src="thankYouImage" width="45%" alt="Corenroll">
      </div>
      <div class="content mt-3">
        <!-- <h1>
          <span class="head_grey">Thank you for choosing our</span><br>Insurance Plans.
        </h1> -->
        <h2>Your plans will be effective as of {{effective}}</h2>
        <div class="proceed-btn">
          <button class="back" type="button" id="backCart" name="button" @click="navigatePrevious">Back to Cart</button>
          <button class="proceed" type="button" id="beginEnroll" name="button" @click="nextPage">Proceed to Enrollment</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { baseUrl, Domain } from '../config/config';

// import axios from 'axios';


export default {
    name: "Confirmation",
    props:{
    effective: String,
  },
    data: function () {
      return {
        tempId : window.localStorage.getItem('tempId'),
        thankYouImage: ''
      }
    },
    mounted() {
        let app = this;
        app.tempId = window.localStorage.getItem('tempId');
        app.fetchCatchInfo()
    },
    methods: {
        nextPage: function() {
          this.$emit('Checkoutcart');
          localStorage.setItem('enrollment','new_enrollment');
          this.$router.push('enrollment/personal-info');
        },
        navigatePrevious: function() {
          this.$emit('hidePopUp');
        },
        fetchCatchInfo() {
          let siteDomain = window.btoa(unescape(encodeURIComponent(Domain)))
          // let siteDomain = 'aHR0cHM6Ly9lbnJvbGwucHVyZW5yb2xsLmNvbQ=='
          let url = `${baseUrl}/api/v1/get-external-site-dynamic-information?site_domain=${siteDomain}`
          caches.open('fetch_color_cache').then((cache) => {
            cache.match(url).then(response => {
              response.json().then(data => {
                let getCatchColor = []
                let newObj = {}
                getCatchColor = data
                getCatchColor.map(item => {
                  newObj[item.key] = item.value;
                });
                this.thankYouImage = newObj["VUE_APP_THANK_YOU"]
              })
            })
          }).catch((err) => {
            console.log(err);
          })
        }
    }
}
</script>

<style scoped>

</style>
